import { render, staticRenderFns } from "./question-root-node.vue?vue&type=template&id=28a80988&scoped=true&"
import script from "./question-root-node.vue?vue&type=script&lang=js&"
export * from "./question-root-node.vue?vue&type=script&lang=js&"
import style0 from "./question-root-node.vue?vue&type=style&index=0&id=28a80988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a80988",
  null
  
)

export default component.exports